import { useRef } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import type { ActionMenuItem } from './types';
import { filterAvailableActions } from './filterActions';
import { useAdminAccess } from '@/shared/model/adminAccess';
import buttonClasses from '@/styles/buttons.module.scss';
import menuClasses from '@/shared/ui/RowContextMenu/RowContextMenu.module.scss';

interface ActionMenuProps {
    model: ActionMenuItem[];
    id?: string;
    menuClassName?: string;
    label?: string;
    disabled?: boolean;
    'aria-label'?: string;
}

/** Показывает меню доступных прикладных действий */
export const ActionMenu = (
    {
        model,
        id,
        menuClassName,
        label,
        disabled = false,
        'aria-label': ariaLabel = 'Дополнительные действия',
    }: ActionMenuProps
) => {
    const snapshot = useAdminAccess((state) => state.snapshot);
    const menuRef = useRef<Menu>(null);

    const items = filterAvailableActions(model, snapshot);

    if (items.length === 0) return null;

    return <>
        <Button
            type="button"
            icon={label
                ? 'pi pi-angle-down'
                : 'pi pi-ellipsis-h'
            }
            label={label}
            className={label
                ? buttonClasses.actionButton
                : buttonClasses.menuIcon
            }
            aria-label={ariaLabel}
            disabled={disabled}
            onClick={(event) => menuRef.current?.toggle(event)}
        />
        <Menu
            id={id}
            model={items}
            popup
            ref={menuRef}
            className={`${menuClasses.contextMenu} ${menuClassName ?? ''}`}
        />
    </>;
};
